import { render, staticRenderFns } from "./GoodsGroupContent.vue?vue&type=template&id=f30e6c76&"
import script from "./GoodsGroupContent.vue?vue&type=script&lang=js&"
export * from "./GoodsGroupContent.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroupContent.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./GoodsGroupContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports